import { Group } from '@mantine/core';
import BestPriceButton from './BestPriceButton';
import BestPriceLabel, { type BestPriceAction, type BestPriceTone } from './BestPriceLabel';

interface BestPriceLinkProps {
  /** Ссылка на страницу встречного предложения с действием «Купить»/«Продать». */
  readonly to: string;
  /** Лучшая встречная цена, ₽/т (sell — FCA, buy — CPT). */
  readonly price: number;
  readonly action: BestPriceAction;
  /** `gain` — кнопка залита (см. BestPriceButton). */
  readonly tone?: BestPriceTone;
  /** Выгода относительно моей цены, ₽/т (со знаком) — только где есть привязка. */
  readonly advantage?: number;
  /** Отличие от соседних кнопок для доступного имени (строка качества, предоплата). */
  readonly context?: string;
}

// Единый элемент лучшей цены для всех разделов: слева число и выгода, справа кнопка «Продать»/«Купить».
// Ссылка — только кнопка; число и выгода — обычный текст рядом. Решение «показывать ли действие» (например,
// скрыть у агента) — у вызывающего.
export default function BestPriceLink({ to, price, action, tone, advantage, context }: BestPriceLinkProps) {
  return (
    // В узкой ячейке (сетка «Купить» на телефоне) кнопка переносится под число, а не вылезает за край.
    <Group justify="space-between" align="center" gap="sm">
      <BestPriceLabel price={price} action={action} advantage={advantage} />
      <BestPriceButton to={to} action={action} tone={tone} price={price} context={context} />
    </Group>
  );
}
